import React, {RefObject, useEffect, useRef, useState} from "react";
import {Select} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {userService} from "../../../../services/user/user.service";
import {SystemUserAccess} from "../../../../models/user/user";
import {useRequiredLayers} from "../../../../utils/context";
import {RootStore, RootStoreContext} from "../../../../stores/root/root";
import {RootControllers, RootControllersContext} from "../../../../controllers/root/root.controllers";

const buildKey = (accessId: number, branch: string): string => {
    return branch + "|" + accessId;
}

const parseKey = (key: string): {branch: string, accessId: number} => {
    const data = key.split('|')
    return {
        branch: data[0],
        accessId: parseInt(data[1])
    }
}

export const NavigationSwitchAccountWidget: React.FC = () => {

    const {
        store: { authStore },
        controller: { loginController },
    } = useRequiredLayers<RootStore, RootControllers>(RootStoreContext, RootControllersContext);

    const [accesses, setAccesses] = useState<SystemUserAccess[]>([]);
    const [roleSwitcherMenuOpened, setRoleSwitcherMenuOpened] = useState<boolean>(false);

    const roleSwitcherWrapper = useRef<HTMLElement>(null) as RefObject<any>;

    useEffect(() => {
        const closePopupHandler = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (!roleSwitcherWrapper?.current?.contains(target)) {
                setRoleSwitcherMenuOpened(false);
            }
        };

        document.addEventListener("mousedown", closePopupHandler);

        return () => {
            document.removeEventListener("mousedown", closePopupHandler);
        };
    }, []);

    useEffect(() => {
        Promise.all(authStore.availableServers.map(server => {
            return userService.getAccesses(server);
        })).then(values => setAccesses(values.flat()))
    }, [authStore.availableServers]);

    if (accesses.length === 0) {
        return <></>;
    }

    return (
        <>
            {accesses.length > 1 ? (
                <div
                    ref={roleSwitcherWrapper}
                    onClick={() => setRoleSwitcherMenuOpened(!roleSwitcherMenuOpened)}
                    className="page_header_language-wrapper"
                    onKeyDown={(event) => {
                        if (event.keyCode === 13) {
                            setRoleSwitcherMenuOpened(!roleSwitcherMenuOpened);
                        }
                    }}
                >
                    <FontAwesomeIcon icon={["fas", "briefcase"]} style={{marginRight: 0}} size={"lg"}/>
                    <Select<string>
                        open={roleSwitcherMenuOpened}
                        className="page_header_language-select"
                        value={buildKey(authStore.getAccess(), authStore.branch)}
                        onChange={(value: string) => {
                            const auth = parseKey(value);
                            loginController.switchRole(auth.accessId, auth.branch)
                        }}
                        bordered={false}
                        getPopupContainer={() => roleSwitcherWrapper.current}
                    >
                        {accesses.map((access) => (
                            <Select.Option key={buildKey(access.id, access.branchId)} value={buildKey(access.id, access.branchId)}>
                                {access.businessName}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ) : null}
        </>
    )
}